import React, { useState, useEffect } from 'react';

/**
 * ProtectedEmail - Protects email addresses from scrapers/bots
 * The email is encoded and only decoded via JavaScript on user interaction
 */
export const ProtectedEmail = ({ 
  user = "info", 
  domain = "nauticabrusa.ch",
  className = "",
  showIcon = false,
  testId = "protected-email"
}) => {
  const [email, setEmail] = useState('');
  const [revealed, setRevealed] = useState(false);

  // Decode email on component mount (only in browser, not for bots)
  useEffect(() => {
    // Small delay to avoid immediate scraping
    const timer = setTimeout(() => {
      setEmail(`${user}@${domain}`);
    }, 100);
    return () => clearTimeout(timer);
  }, [user, domain]);

  const handleClick = (e) => {
    if (!revealed) {
      e.preventDefault();
      setRevealed(true);
      // Open mailto after revealing
      setTimeout(() => {
        window.location.href = `mailto:${user}@${domain}`;
      }, 50);
    }
  };

  // Display obfuscated version for initial render (what bots see)
  const obfuscatedDisplay = `${user}[at]${domain.replace('.', '[dot]')}`;

  return (
    <a
      href={revealed ? `mailto:${email}` : '#'}
      onClick={handleClick}
      className={className}
      data-testid={testId}
      aria-label={`Invia email a ${user} at ${domain}`}
    >
      {email || obfuscatedDisplay}
    </a>
  );
};

export default ProtectedEmail;
